<template>
    <section>
        <v-dialog v-model="dialog" persistent max-width="750px">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <v-flex v-if="!Update_Details">Add Mini Projects</v-flex>
                    <v-flex v-else>Update Mini Projects</v-flex>
                    <v-btn icon @click="CloseDialog">
                        <v-icon color="text--secondary">close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text v-if="!Update_Details">

                    <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-select item-value='_id' item-text='name' return-object v-model="SelectedMiniProject" :items="MiniProjects" label="Select Mini Project">
                                <template slot='selection' slot-scope='{ item }'>
                                    {{ item.Project_Title }}
                                </template>
                                <template slot='item' slot-scope='{ item }'>
                                    {{ item.Project_Title }}    
                                </template>
                            </v-select>
                        </v-layout>
                        <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                            <v-flex v-if="this.File && this.File.type.split('/')[1] == 'mp4'">
                                <video id="video_mini_project" loop controls width="100%" :src="url" ></video>
                            </v-flex>
                            <v-flex v-if="this.File" style="text-align: center;font-size: 16px;padding: 12px;">
                                {{ File.name }} <v-icon color='red' @click="DeleteFile">delete</v-icon>
                            </v-flex>
                            <v-flex style="text-align: center;">
                                <v-btn color="success" @click="$refs.inputUpload.click()">Upload File</v-btn>
                                <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                            </v-flex>
                        </div>
                    </v-flex>
                </v-card-text>
                <v-card-text v-else>
                     <v-flex wrap style="padding: 10px;">
                        <v-layout row>
                            <v-flex style="font-size: 16px;font-weight: bold;">Project Title :  {{ Project_Title }}</v-flex>
                        </v-layout>

                        <v-radio-group v-model="Upload_Type" row>
                            <v-radio :label="`Project Video`" value="Project Video"></v-radio>
                            <v-radio :label="`Project Zip/File`" value="Project Zip/Files"></v-radio>
                        </v-radio-group>
                        <section v-if="Upload_Type == 'Project Video'">
                             <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex>
                                    <video id="video_mini_project" loop controls width="100%" :src="url" ></video>
                                </v-flex>
                                <v-flex style="text-align: center;">
                                    <v-btn color="success" @click="$refs.inputUpload.click()">Upload File</v-btn>
                                    <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                                </v-flex>
                            </div>
                        </section>
                        <section v-else>
                            <div style="width:400px;margin:auto;border: 1px solid #d3d3d37a;">
                                <v-flex v-if="this.File" style="text-align: center;font-size: 16px;padding: 12px;">
                                    {{ File.name }} <v-icon color='red' @click="DeleteFile">delete</v-icon>
                                </v-flex>
                                <v-flex style="text-align: center;">
                                    <v-btn color="success" @click="$refs.inputUpload.click()">Upload File</v-btn>
                                    <input v-show="false" ref="inputUpload" type="file" @change="SelectedFile" >
                                </v-flex>
                            </div>
                        </section>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-flex style="text-align: right;">
                        <v-btn color="success" v-if="!Update_Details" @click="ValidateToSubmit">Add Mini Project Files</v-btn>
                        <v-btn color="success" v-else @click="ValidateToUpdate">Update Mini Project Files </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
  </section>
</template>
<script>
import { VueEditor } from "vue2-editor";

export default {
    components: {
        VueEditor
    },
    props: ['dialog'],
    data(){
        return {

            Update_Details          : false,
            SelectedMiniProject     : {},
            MiniProjects            : [],
            url                     : null,
            File                    : null,
            Project_Title           : "",
            Project_Id              : "",
            Upload_Type             : 'Project Video'
        }
    },  
    methods:{
        CloseDialog(){
            
            this.ClearForm()
            this.$emit('close')
        },
        GetDetailstoUpdate(Project){
            
            this.GetMiniProjectList()
                .then(response =>{
                    
                    this.Update_Details      = true
                    this.SelectedMiniProject = Project
                    this.Project_Id     = Project['_id']
                    this.Project_Title  = Project['Project_Title']
                    this.url            = Project['Project_Video']
                })
                .catch(error =>{

                    console.log(error)
                })
        },
        ClearForm(){

            this.File  = null
            this.url   = null
            this.Upload_Type = 'Project Video'
            this.SelectedMiniProject = {}
            this.Update_Details      = false
            this.MiniProjects        = []
            this.Project_Id          = ''
            this.Project_Title       = ""
            this.DeleteFile()
        },
        GetMiniProjectList(){

            return new Promise((resolve,reject) =>{

                this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/getminiprojects`,{})
                            .then(response =>{
    
                                this.MiniProjects = response["data"]["response"]
                                resolve(true)
                            })
                            .catch(err =>{
    
                                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Fetch Data","Color":"red","Close": false });
                                reject(err)
                            })
            })

        },
        SelectedFile(e){
            
            let Type = e.target.files[0]['type'].split('/')[1]
            if(Type == 'zip' || Type == 'vnd.rar' || Type == 'mp4' ){

                this.File       = e.target.files[0]
                this.url         = URL.createObjectURL(this.File);
                this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Selected File","Color":"green","Close": false });
                    
            }else{

               this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Check The Selected File Type","Color":"red","Close": false });
            }
        },
        DeleteFile(){

            this.File = null
            this.url  = null
        },
        ValidateToSubmit(){

            let Type = this.File['type'].split('/')[1]
            if(Type == 'zip' || Type == 'vnd.rar' ){

                this.SubmitZipFile()

            }else if(Type == 'mp4'){

                this.SubmitVideoFile()

            }
        },
        SubmitVideoFile(){

            const fd = new FormData()
            fd.append('Project_Id',this.MiniProjects.find(x => x["Project_Title"] == this.SelectedMiniProject['Project_Title'])["_id"])
            fd.append('Project_Video',this.File,this.File.name)

            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/addvideos`,fd)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Video","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Video","Color":"red","Close": false });
                        })
        },
        SubmitZipFile(){

            const fd = new FormData()
            fd.append('Project_Id',this.MiniProjects.find(x => x["Project_Title"] == this.SelectedMiniProject['Project_Title'])["_id"])
            fd.append('Project_File',this.File,this.File.name)

            this.$http.post(`${this.$store.getters.GetProductionUrl}/miniproject/addfile`,fd)
                        .then(response =>{
                            
                            this.$store.commit('UpdateIndividualProjects',response["data"]["response"])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Updated Video","Color":"green","Close": false });
                            this.CloseDialog()
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Update Video","Color":"green","Close": false });
                        })
        },
        ValidateToUpdate(){
            
            let Type = this.File['type'].split('/')[1]
            if(Type == 'zip' || Type == 'vnd.rar' ){

                this.SubmitZipFile()

            }else if(Type == 'mp4'){

                this.SubmitVideoFile()

            }

        }
    }
}
</script>
<style scoped>

</style>